

<script>
/* eslint-disable */
export default {
    created() {
        
        this.$store.commit('clearAllData');

        this.$store.dispatch('destroyToken')
        .then((response)=>{
             this.$router.push({name:'login'})
        })
        .catch(error => {
                this.$router.push({name:'login'})
         });
    },
    render : ()=> {},
}
</script>

<style>

</style>
